// extracted by mini-css-extract-plugin
module.exports = {"main":"outPatientStatistics_main__2MXh_","container":"outPatientStatistics_container__1XzoW"};